(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $(".about__accordion-toggle");

		aboutToggleItems.each(function () {
			const currentToggle = $(this);
			const siblingToggles = currentToggle.siblings(
				".about__accordion-description"
			);

			currentToggle.click(function () {
				if (!currentToggle.hasClass("active")) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this);
						siblingToggle.removeClass("active");
						siblingToggle
							.siblings(".about__accordion-description")
							.stop()
							.slideUp(300);
					});

					currentToggle.addClass("active");

					siblingToggles.stop().slideDown(300);
				} else {
					currentToggle.removeClass("active");
					siblingToggles.stop().slideUp(300);
				}
			});
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper?.querySelectorAll(".js-image-zoom") || [];

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = theme.moneyFormat;

		return formatString.replace(placeholderRegex, value);
	};

	const setTotalFreeShipping = () => {
		if (document.querySelector(".js-free-shipping")) {
			const freeShippingTotal = document.querySelector(".free-shipping-total");
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend);
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`;
				}
			}
		}
	};

	const initFloatingAtcVisibility = () => {
		const floatingCards = document.querySelectorAll(".floated_form[data-section-id]");
		if (!floatingCards.length) return;

		floatingCards.forEach((card) => {
			const sectionId = card.dataset.sectionId;
			const mainSubmit = document.querySelector(
				`#MainProduct-${sectionId} .product-form__submit`
			);

			if (!mainSubmit) return;

			const updateVisibility = () => {
				const rect = mainSubmit.getBoundingClientRect();
				const isVisible =
					rect.bottom > 0 &&
					rect.top < window.innerHeight &&
					rect.left < window.innerWidth &&
					rect.right > 0;

				card.classList.toggle("active", !isVisible);
			};

			updateVisibility();

			document.addEventListener("scroll", updateVisibility, { passive: true });
			window.addEventListener("resize", updateVisibility);
			mainSubmit.addEventListener("transitionend", updateVisibility);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		setTotalFreeShipping();
		initFloatingAtcVisibility();
	});

	initProductAccordion();
	setTotalFreeShipping();
	initFloatingAtcVisibility();
})();

document.addEventListener('change', (event) => {
	const picker = event.target.closest('variant-radios, variant-selects');
	if (!picker) return;

	const variant = picker.currentVariant;
	if (!variant) return;

	const inventoryQty = window.variantInventory?.[variant.id] ?? 0;

	const allowedSizes = ["XS","S","M","L","XL","XXL","XXXL"];

	function isSize(value) {
		if (!value) return false;
		
		const v = value.trim().toUpperCase();
		
		return !isNaN(Number(v)) || allowedSizes.includes(v);
	}

	const sizeEl = document.getElementById('current-size-value');
	const colorEl = document.getElementById('current-color-value');

	if (sizeEl) sizeEl.textContent = isSize(variant.option1) ? variant.option1 : variant.option2;
	if (colorEl) colorEl.textContent = isSize(variant.option1) ? variant.option2 : variant.option1;

	// Low stock
	const stockEl = document.getElementById('low-stock-info');
	if (!stockEl) return;

	const threshold = Number(stockEl.dataset.threshold);
	const text = stockEl.dataset.text;
	
	stockEl.textContent =
		inventoryQty <= threshold && inventoryQty > 0 ? text : '';
});

if (document.querySelector(".show-more-images")) {
	const showMoreBtn = document.querySelector(".show-more-images");

	showMoreBtn.addEventListener("click", e => {
		const target = e.currentTarget
		const gallery = target.previousElementSibling

		if (gallery.classList.contains("hide-images")) {
			gallery.classList.remove("hide-images")
		}

		target.style.display = "none";
	})
}
